module.exports = __webpack_public_path__ + "static/media/account.4f3596bf.svg";